import PageBox from "PFComponents/box/page_box";
import { Button } from "PFComponents/button";
import Toggle from "PFComponents/toggle/toggle";
import useClickOutside from "PFCore/helpers/use_click_outside";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";

import css from "../audit_planner_page.module.scss";
const AllocationButtonDropdown = ({
  isAlwaysAllocateOn,
  setAlwaysAllocate,
  allocationReady,
  startWorkflowAutomation,
  onClose
}) => {
  const { t } = useTranslation("auditPlanner", { keyPrefix: "allocationButton.dropdownMenu" });

  const ref = React.useRef();
  useClickOutside(ref, onClose);

  return (
    <div className={css.allocationPop} ref={ref}>
      <PageBox>
        <div className={css.allocationPopSize}>
          <Button
            text={t("runOnce")}
            kind="text"
            disabled={isAlwaysAllocateOn || !allocationReady}
            onClick={startWorkflowAutomation}
          />
          <Toggle
            inline
            checked={isAlwaysAllocateOn}
            onChange={(status) => {
              setAlwaysAllocate(status);
            }}
            description={t("alwaysOn")}
            reversed
          />
        </div>
      </PageBox>
    </div>
  );
};

AllocationButtonDropdown.propTypes = {
  onClose: PropTypes.func,
  startWorkflowAutomation: PropTypes.func.isRequired,
  isAlwaysAllocateOn: PropTypes.bool.isRequired,
  setAlwaysAllocate: PropTypes.func.isRequired,
  allocationReady: PropTypes.bool
};

export default AllocationButtonDropdown;
